<template>
  <nav class="ksm-navbar">
    <template v-for="(it, i) in navList">
      <a
        v-tooltip="it.disable?tooltipOption:''"
        :key="i"
        :class="{active:it.names.indexOf(routeName)>-1, disable:it.disable}"
        class="ksm-navitem ksm-link-text"
        @click="toPage(it)"
      >{{it.label}}</a>
    </template>
  </nav>
</template>

<script>
export default {
  data() {
    return {
      tooltipOption: {
        content: "Es ist vorgesehen, hier die bildnerischen Werke des aktualisierten „Kurt Schwitters. Catalogue raisonné“ bereitzustellen.",
        placement: "bottom-center",
        classes: ["info"]
      },
      navItems: [
        {
          path: "/kunstwerke",
          names: ["kunstwerke"],
          label: "Kunstwerke",
          disable: true
        },
        {
          path: "/texte/merzhefte",
          names: ["texte-modus", "texte", "ursonate"],
          label: "Texte"
        },
        {
          path: "/merzwerbe/untersuchungsmodus",
          names: ["werbe-modus"],
          label: "Merz-Werbe"
        },
        {
          path: "/personen",
          names: ["personen"],
          label: "Personen"
        },
        {
          path: "/orteundwege",
          names: ["orteundwege"],
          label: "Orte und Wege"
        },
        {
          path: "/bibliographie",
          names: ["bibliographie"],
          label: "Bibliographie"
        },
        {
          path: "/suche",
          names: ["suche"],
          label: "Suche"
        },
        {
          path: "/hilfe",
          names: ["hilfe"],
          label: "Hilfe"
        }
      ]
    };
  },
  created: function() {},
  watch: {},
  computed: {
    routeName() {
      return this.$route.name;
    },

    navList() {
      return this.navItems.map(it => {
        return it;
      });
    }
  },
  methods: {
    toPage(it) {
      if (it.disable) {
        return;
      }
      this.$router.push({
        path: it.path
      });
    }
  }
};
</script>

<style lang="scss">
.ksm-navbar {
  @extend .ksm-flex-xy-center;
  min-width: 716px;
  height: 34px;
  font-size: 12px;
  align-items: flex-end;
  a {
    cursor: pointer;
  }
}
.ksm-navitem {
  @extend .ksm-flex-xy-center;
  margin: 0px 5px;
  padding: 5px 10px 8px 10px;
  background-color: rgb(51, 83, 121);
  color: rgb(173, 186, 201);
  transition: height 0.1s ease-in;
  height: 20px;
  &.disable {
    cursor: default;
    &:hover {
      color: rgb(173, 186, 201);
    }
  }
}
.ksm-navitem.active {
  background-color: rgb(128, 148, 171);
  color: #fff;
  height: 30px;
}

</style>


// WEBPACK FOOTER //
// Nav.vue?a79cef08